module.exports = {
  "defaultCurrency": null,
  "currencies": []
}